import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core";
import { policies, LAST_UPDATED } from "../../../data/policies";

const useStyles = makeStyles({
  root: {
    padding: "120px 0 80px",
    width: "90%",
    maxWidth: "900px",
    margin: "0 auto",
    fontFamily: "Roboto",
    color: "#2C2C2C",
  },
  heading: {
    fontSize: "36px",
    fontWeight: 600,
    fontFamily: "Poppins",
    marginBottom: "8px",
  },
  updated: {
    fontSize: "14px",
    color: "#777777",
    marginBottom: "32px",
    paddingBottom: "16px",
    borderBottom: "2px solid #FC8019",
  },
  intro: {
    fontSize: "16px",
    lineHeight: 1.7,
    marginBottom: "24px",
  },
  sectionHeading: {
    fontSize: "20px",
    fontWeight: 600,
    fontFamily: "Poppins",
    color: "#8b003c",
    margin: "32px 0 12px",
  },
  paragraph: {
    fontSize: "16px",
    lineHeight: 1.7,
    margin: "0 0 12px",
  },
  list: {
    fontSize: "16px",
    lineHeight: 1.7,
    margin: "0 0 12px",
    paddingLeft: "24px",
    "& li": {
      marginBottom: "6px",
    },
  },
});

const PolicyPage = ({ type }) => {
  const classes = useStyles();
  const policy = policies[type];

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${policy.title} | PickaaGo`;
  }, [policy.title]);

  return (
    <div className={classes.root}>
      <h1 className={classes.heading}>{policy.title}</h1>
      <div className={classes.updated}>Last updated: {LAST_UPDATED}</div>
      <p className={classes.intro}>{policy.intro}</p>
      {policy.sections.map((section) => (
        <section key={section.heading}>
          <h2 className={classes.sectionHeading}>{section.heading}</h2>
          {section.body.map((block, index) =>
            Array.isArray(block) ? (
              <ul key={index} className={classes.list}>
                {block.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : (
              <p key={index} className={classes.paragraph}>
                {block}
              </p>
            )
          )}
        </section>
      ))}
    </div>
  );
};

export default PolicyPage;
